import { ProductionMixResultRead } from "store/api/generatedApi";
import { useTenantTranslation, useUnitsFormatter } from "hooks/formatters";
import { useNumberSerialiser } from "hooks/serialisers/numbers";
import { Snackbar } from "@mui/material";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { recipeDecimalPlaces } from "src/constants";
import { buildRecipeText } from "./productionContent";

export const CopyPlanButton = ({
  percentageBreakdown,
  results,
}: {
  percentageBreakdown: boolean;
  results: ProductionMixResultRead[];
}) => {
  const { t } = useTenantTranslation();
  const units = useUnitsFormatter(false);

  const unitString: string = units(
    percentageBreakdown ? "mass_fraction" : "mass"
  );

  const { format } = useNumberSerialiser({
    decimalPlaces: recipeDecimalPlaces,
  });

  const recipeTexts = results.map((result) =>
    buildRecipeText(result, percentageBreakdown, format, unitString)
  );

  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(true);
    void navigator.clipboard.writeText(recipeTexts.join("\n"));
  };

  return (
    <>
      <LoadingButton
        variant="text"
        color="primary"
        onClick={handleClick}
        startIcon={<FileCopyIcon />}
        sx={{ whiteSpace: "nowrap" }}
      >
        {t("copyRecipeToClipboard")}
      </LoadingButton>
      <Snackbar
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        autoHideDuration={2000}
        message={t("recipeCopiedToClipboard")}
      />
    </>
  );
};
